/**
 * @file JS - classes/Page/ElementLegende.js
 * @author : Adam Lemire
 * @since 2021/10/05
 * @version 1.0
 * @summary Dernières modifications : 2021/11/23
 */

import { hideContextMenus } from '../../../helpers/GlobalFunctions';
import { Evenements } from '../../../events/Evenements.js';

require('jquery-ui/ui/core');
require('jquery-ui/ui/widgets/accordion');
require('jquery-ui/ui/widgets/spinner');
require('jquery-ui/ui/widgets/resizable');
require('jquery-ui/ui/widgets/draggable');
require('jquery-ui/ui/widgets/slider');
require('jquery-ui/ui/effects/effect-size');
require('jquery-ui/ui/effects/effect-slide');
require('jquery-ui/themes/base/base.css');
require('jquery-ui/themes/base/draggable.css');
require('jquery-ui/themes/base/theme.css');
require('jquery-ui/themes/base/spinner.css');
require('jquery-ui/themes/base/button.css');
require('jquery-ui/themes/base/resizable.css');
require('jquery-ui/themes/base/slider.css');
require('jquery-ui/themes/base/accordion.css');

export default class ElementLegende {
  constructor (idLayout, objetJSON = false) {
    if (!objetJSON) {
      this._idDiv = 'layout-' + idLayout + '__element-legende';
      this._idDivLayout = 'layout-page-' + idLayout;
      this._idLayout = idLayout;
      this._taillePolice = 14;
      this._couleurTexte = '#000000';
      this._transparenceArrierePlan = 0;
      this._largeur = 200;
      this._positionX = 0;
      this._positionY = 0;
      this._compteurElements = 0;
      this._tailleBordure = 0;
    } else {
      this._creerDepuisJSON(objetJSON);
    }
  }

  creerDiv () {
    const _this = this;
    const conteneur = '#' + this._idDivLayout + ' .export-layout__preview-map';
    const div = document.createElement('div');
    const divIdJQ = '#' + this._idDiv;

    div.id = this._idDiv;
    div.className = 'layout__element layout__element-legende';
    div.style.position = 'absolute';
    div.style.left = this._positionX + 'px';
    div.style.top = this._positionY + 'px';
    div.style.width = 'auto';
    div.style.height = 'auto';
    div.style.background = 'rgba(255, 255, 255, ' + (1 - this._transparenceArrierePlan) + ')';
    div.style.color = this._couleurTexte;
    div.style.fontSize = this._taillePolice + 'px';
    div.style.textAlign = 'center';
    div.style.display = 'flex';
    div.style.alignItems = 'center';

    $(conteneur).append(div);

    $(divIdJQ).draggable({
      cursor: 'move',
      stop: function (event, ui) {
        _this._positionX = ui.position.left;
        _this._positionY = ui.position.top;
      }
    });

    $(divIdJQ).resizable({
      handles: 'e, w',
      stop: function (event, ui) {
        _this._largeur = ui.size.width;
      }
    });
    this._ajouterConteneurInterne();
    this._ajouterCouchesPresentes();
  }

  rafraichirContenuLegende () {
    const divConteneurInterneJQ = '#' + this._idDiv + ' .element-legende__conteneur';
    $(divConteneurInterneJQ).empty();
    this._ajouterCouchesPresentes();
  }

  _ajouterConteneurInterne () {
    const divIdConteneurJQ = '#' + this._idDiv;
    const conteneurInterne = '<div class="element-legende__conteneur"></div>';

    $(divIdConteneurJQ).append(conteneurInterne);
  }

  _ajouterCouchesPresentes () {
    const _this = this;
    const checkboxCouchesCartes = '.map-layers .map-layers__checkbox';
    this._compteurElements = 0;

    $(checkboxCouchesCartes).each(function (checkbox) {
      const coucheJQ = $(this).parent();
      if ($(this).is(':checked')) {
        _this._compteurElements++;
        if (coucheJQ.children('.map-layers__legend').children().first().hasClass('legend__single-symbol')) {
          _this._ajouterCoucheStyleUnique(coucheJQ);
        } else if (coucheJQ.children('.map-layers__legend').children().first().hasClass('legend__multi-styles')) {
          _this._ajouterCoucheStyleMultiple(coucheJQ);
        }
      }
    });
  }

  _ajouterCoucheStyleUnique (coucheJQ) {
    const divIdConteneurInterneJQ = '#' + this._idDiv + ' .element-legende__conteneur';
    const elementLegende = '<div id="element-legende-' + this._idLayout + '__element-' + this._compteurElements + '" class="element-legende__element element-legende__style-unique"></div>';
    const idElementLegendeJQ = '#element-legende-' + this._idLayout + '__element-' + this._compteurElements;

    $(divIdConteneurInterneJQ).append(elementLegende);
    coucheJQ.children('.map-layers__legend').clone().appendTo(idElementLegendeJQ);
    coucheJQ.children('.map-layers__text').clone().appendTo(idElementLegendeJQ);
  }

  _ajouterCoucheStyleMultiple (coucheJQ) {
    const divIdConteneurInterneJQ = '#' + this._idDiv + ' .element-legende__conteneur';
    const elementLegende = '<div id="element-legende-' + this._idLayout + '__element-' + this._compteurElements + '" class="element-legende__element element-legende__style-multiple"></div>';
    const idElementLegendeJQ = '#element-legende-' + this._idLayout + '__element-' + this._compteurElements;

    $(divIdConteneurInterneJQ).append(elementLegende);
    coucheJQ.children('.map-layers__text').clone().appendTo(idElementLegendeJQ);
    coucheJQ.children('.map-layers__legend').clone().appendTo(idElementLegendeJQ);
  }

  creerDivEditeur () {
    const divEditeurId = 'editeur-element-legende';
    const divEditeur = '<h3 id="bouton-editeur-element-legende" class="bouton-editeur-element" data-text="layoutPage.editeur.legende.titre"></h3><table id="' + divEditeurId + '" class="editeur-element editeur-element-legende"></table>';

    $('.conteneur__editeur-element').append(divEditeur);

    this._creerDivEditeurTaillePolice();
    this._creerDivEditeurBordure();
    $('.conteneur__editeur-element').accordion('refresh');
    $('.conteneur__editeur-element').accordion('option', 'active', -1);
    Evenements.texteAjoute.notify();
    // this._ecouterAfficherMenuContectuel();
  }

  _ecouterAfficherMenuContectuel () {
    const boutonEditeurElementIdJq = '#bouton-editeur-element-legende';
    const menuContextuelIdJQ = '#context-menu-' + this._idDiv;
    let menu;

    if (!document.getElementById('context-menu-' + this._idDiv)) {
      menu = document.createElement('div');

      menu.id = 'context-menu-' + this._idDiv;
      menu.className = 'context-menu context-menu-editeur-element hidden';

      $('.inner-windows').append(menu);
      const optionSupprimer = '<ul class="context-menu__options"><li class="context-menu__option context-menu__option-editeur-element-legende" data-text="contextMenu.remove"></li></ul>';

      $(menuContextuelIdJQ).append(optionSupprimer);
      Evenements.texteAjoute.notify();
      this._ecouterEnleverEditeurElement();
    } else {
      menu = document.getElementById('context-menu-' + this._idDiv);
    }

    const setPosition = ({
      top,
      left
    }) => {
      hideContextMenus();
      menu.style.left = `${left}px`;
      menu.style.top = `${top}px`;
      $(menuContextuelIdJQ).removeClass('hidden');
    };

    $(boutonEditeurElementIdJq).on('contextmenu', e => {
      e.preventDefault();
      const origin = {
        left: e.pageX,
        top: e.pageY
      };
      setPosition(origin);
      return false;
    });
  }

  /* _ecouterEnleverEditeurElement () {
    const optionEnleverClasseJQ = '.context-menu__option-editeur-element-legende';
    const divElementIdJQ = '#' + this._idDiv;
    const enteteEditeurIdJQ = '#bouton-editeur-element-legende';
    const divEditeurIdJQ = '#editeur-element-legende';
    const menuContextuelIdJQ = '#context-menu-' + this._idDiv;

    $(optionEnleverClasseJQ).off('click tap');
    $(optionEnleverClasseJQ).on('click tap', function () {
      $(divElementIdJQ).remove();
      $(enteteEditeurIdJQ).remove();
      $(divEditeurIdJQ).remove();
      $(menuContextuelIdJQ).remove();
      $('.export-layout__legend-button').attr('disabled', false);
      // ! doit supprimer cet element légende
    });
  } */

  // ! vérifier ce qui se produit avec points
  _creerDivEditeurTaillePolice () {
    const _this = this;
    const divEditeurId = 'editeur-element-legende';
    const divEditeurIdJQ = '#' + divEditeurId;
    const inputJQ = '#' + divEditeurId + '__taille';
    const tailleEditeur = '<tr><td><label for="' + divEditeurId + '__taille" data-text="layoutPage.editeur.legende.taille"></label></td>' +
      '<td><input id="' + divEditeurId + '__taille" class="' + divEditeurId + '__taille" name="' + divEditeurId + '__taille" value="' + this._taillePolice + '"></td></tr>';

    $(divEditeurIdJQ).append(tailleEditeur);
    $(inputJQ).spinner({
      min: 0,
      max: 50,
      stop: function (event, ui) {
        const paragrapheJQ = '#' + _this._idDiv;
        _this._taillePolice = parseInt(event.target.value);
        $(paragrapheJQ).css('font-size', event.target.value + 'px');
      }
    });
  }

  _creerDivEditeurBordure () {
    const _this = this;
    const divEditeurId = 'editeur-element-legende';
    const divEditeurIdJQ = '#' + divEditeurId;
    const inputJQ = '#' + divEditeurId + '__bordure';
    const paragrapheJQ = '#' + this._idDiv;
    const tailleEditeur = '<tr><td><label for="' + divEditeurId + '__bordure" data-text="layoutPage.editeur.legende.bordure"></label></td>' +
      '<td><input id="' + divEditeurId + '__bordure" class="' + divEditeurId + '__bordure" name="' + divEditeurId + '__bordure" value="' + this._tailleBordure + '"></td></tr>';

    $(divEditeurIdJQ).append(tailleEditeur);
    $(inputJQ).spinner({
      min: 0,
      max: 5,
      stop: function (event, ui) {
        _this._tailleBordure = parseInt(event.target.value);
        $(paragrapheJQ).css('border', event.target.value + 'px solid black');
      }
    });
    $(paragrapheJQ).css('border', this._tailleBordure + 'px solid black');
  }

  /*
   * EXPORTATION ET CREATION DEPUIS JSON
   */

  toJSON () {
    const objetJSON = {
      idDiv: this._idDiv,
      idDivLayout: this._idDivLayout,
      idLayout: this._idLayout,
      taillePolice: this._taillePolice,
      couleurTexte: this._couleurTexte,
      transparenceArrierePlan: this._transparenceArrierePlan,
      largeur: this._largeur,
      positionX: this._positionX,
      positionY: this._positionY,
      compteurElements: this._compteurElements,
      tailleBordure: this._tailleBordure
    };
    return objetJSON;
  }

  _creerDepuisJSON (objetJSON) {
    this._idDiv = objetJSON.idDiv;
    this._idDivLayout = objetJSON.idDivLayout;
    this._idLayout = objetJSON.idLayout;
    this._taillePolice = objetJSON.taillePolice;
    this._couleurTexte = objetJSON.couleurTexte;
    this._transparenceArrierePlan = objetJSON.transparenceArrierePlan;
    this._largeur = objetJSON.largeur;
    this._positionX = objetJSON.positionX;
    this._positionY = objetJSON.positionY;
    this._compteurElements = objetJSON.compteurElements;
    this._tailleBordure = objetJSON.tailleBordure;
  }
}
